import autosize from 'autosize'

autosize(document.querySelectorAll('.component-contact-form textarea'));

let forms = document.querySelectorAll('.component-contact-form form');
forms.forEach(function(form) {
    form.addEventListener("submit", function(event) {
        event.preventDefault();
        form.classList.add('was-validated');
    });
});

let inputs = document.querySelectorAll('.form-floating .form-item input, .form-floating .form-item textarea');
inputs.forEach(function (input) {
    let wrap = input.parentElement;
    input.addEventListener('focus', function () {
        wrap.classList.add('active');
    });
    input.addEventListener('focusout', function (event) {
        if (!input.value) {
            wrap.classList.remove('active');
        }
    })
});
